import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const productCategories = [
  {
    id: "bearings",
    name: "BEARINGS",
    image: "/categories/Bearings.jpg",
    link: "/online-store/bearings"
  },
  {
    id: "braking-steering",
    name: "BRAKING STEERING SYSTEM",
    image: "/categories/Braking-Steering-System.jpg",
    link: "/online-store/braking-steering"
  },
  {
    id: "cooling-systems",
    name: "COOLING SYSTEMS",
    image: "/categories/Cooling-Systems.jpg",
    link: null
  },
  {
    id: "electrical-parts",
    name: "ELECTRICAL PARTS",
    image: "/categories/Electrical-Parts.jpg",
    link: null
  },
  {
    id: "engine-components",
    name: "ENGINE COMPONENTS",
    image: "/categories/Engine-Components.jpg",
    link: null
  },
  {
    id: "filters",
    name: "FILTERS",
    image: "/categories/Filters.jpg",
    link: null
  },
  {
    id: "frame-body",
    name: "FRAME AND BODY",
    image: "/categories/Frame-and-Body.jpg",
    link: null
  },
  {
    id: "fuel-injection",
    name: "FUEL INJECTION",
    image: "/categories/Fuel-Injection.jpg",
    link: null
  },
  {
    id: "ground-engaging",
    name: "GROUND ENGAGING TOOLS",
    image: "/categories/Ground-Engaging-Tools.jpg",
    link: null
  },
  {
    id: "hardware",
    name: "HARDWARE",
    image: "/categories/Hardware.jpg",
    link: null
  },
  {
    id: "hydraulic-parts",
    name: "HYDRAULIC PARTS",
    image: "/categories/Hydraulic-Parts.jpg",
    link: null
  },
  {
    id: "operator-station",
    name: "OPERATOR STATION",
    image: "/categories/Operator-Station.jpg",
    link: null
  },
  {
    id: "power-train",
    name: "POWER TRAIN",
    image: "/categories/Power-Train.jpg",
    link: null
  },
  {
    id: "rubber-tracks",
    name: "RUBBER TRACKS",
    image: "/categories/Rubber-Tracks.jpg",
    link: null
  },
  {
    id: "seals-gaskets",
    name: "SEALS AND GASKETS",
    image: "/categories/Seals-and-Gaskets.jpg",
    link: null
  },
  {
    id: "tools-accessories",
    name: "TOOLS ACCESSORIES",
    image: "/categories/Tools-Accessories.jpg",
    link: null
  },
  {
    id: "turbochargers",
    name: "TURBOCHARGERS",
    image: "/categories/Turbochargers.jpg",
    link: null
  },
  {
    id: "undercarriage",
    name: "UNDERCARRIAGE",
    image: "/categories/Undercarriage.jpg",
    link: null
  }
];

export const OnlineStore = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section className="bg-gray-900 py-16 md:py-20" data-testid="products-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <span className="text-[#F5B800] font-semibold text-sm uppercase tracking-wider mb-4 block">
              MAK Products
            </span>
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4">
              MAK PRODUCT CATEGORIES
            </h1>
            <div className="w-24 h-1 bg-[#F5B800] mx-auto"></div>
          </motion.div>
        </div>
      </section>

      {/* Product Categories Grid */}
      <section className="py-12 md:py-16" data-testid="product-categories">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
            {productCategories.map((category, index) => {
              const CardContent = (
                <>
                  <div className="bg-white border border-gray-200 hover:border-[#F5B800] transition-all duration-300 hover:shadow-lg overflow-hidden">
                    <div className="aspect-square overflow-hidden bg-gray-50 p-4">
                      <img
                        src={category.image}
                        alt={category.name}
                        className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                      />
                    </div>
                  </div>
                  <h3 className="mt-3 text-center font-heading text-xs md:text-sm font-bold text-gray-900 uppercase tracking-wide group-hover:text-[#D4A000] transition-colors">
                    {category.name}
                  </h3>
                </>
              );

              return (
                <motion.div
                  key={category.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.05 }}
                  className="group cursor-pointer"
                  data-testid={`category-${category.id}`}
                >
                  {category.link ? (
                    <Link to={category.link}>
                      {CardContent}
                    </Link>
                  ) : (
                    <div>{CardContent}</div>
                  )}
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-12 md:py-16 bg-[#F5B800]" data-testid="products-cta">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-black mb-2">
                Can't Find What You're Looking For?
              </h2>
              <p className="text-black/70">
                Contact us for custom parts and specialized equipment needs.
              </p>
            </div>
            <a
              href="https://wa.me/971563419000"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="products-whatsapp"
              className="bg-black text-white hover:bg-gray-900 font-bold px-8 py-4 transition-all inline-flex items-center gap-2"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Contact Us on WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};
